// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs, { Dayjs } from "dayjs";

const dayJSToISO = (value: Dayjs | null | undefined) =>
  value && dayjs(value)?.isValid()
    ? `${dayjs(value).format("YYYY-MM-DD")}T00:00:00.000Z`
    : null;

export default dayJSToISO;
